import type { CSSProperties } from "react";

import { colorsPalettes } from "@similarweb/styles";

export const SECOND_LAND = 2;

export const EXTENSION_PROMO_IMAGE = "/images/extension/promo.png";

export const MODAL_STYLES: CSSProperties = {
    width: "488px",
    height: "auto",
    padding: 16,
    borderRadius: 8,
    border: "none",
    background: colorsPalettes.carbon[0],
    overflow: "visible",
};
